import _ from 'lodash';
import {Module, Component} from '../decorators';

import tpl from './ticket.status.html';


@Module({
    name: "app.orders.compontents.ticket.status",
})
@Component({
    selector: 'blnd-ticket-status',
    template: tpl,
    bindings: {
        ngModel: '=',
        mode: '@',
        inputClass: '@',
    },
})
export default class C {
    constructor (Config, $element) {
        "ngInject";
        let self = this;
        self.$element = $element;
        self.statuses = Config.$config.ticket.statuses;
        self.statusMap = _.fromPairs(self.statuses);
    }

    getName () {
        let self = this;
        return self.statusMap[self.ngModel];
    }

    $onDestroy () {
        delete this.statuses;
        delete this.statusMap;
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/ticket.status.js